# This allows us to switch out the underscore utility library
exports._ = require "lodash"



/** WEBPACK FOOTER **
 ** ./framer/Underscore.coffee
 **/